import { Transaction } from "@/modules/warehouses/inventories/view/Transaction"
import { Upsert } from "@/modules/warehouses/inventories/view/Upsert"
import { Route, Routes } from "react-router-dom"
import List from "./view/List"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path=":id/transactions" element={<Transaction />} />
      <Route path=":id" element={<Upsert />} />
    </Routes>
  )
}
